export default __webpack_public_path__ + "static/rig-581f07880a4793b060399d17a9e609f2.mp4";